"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let CoinHistoryModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coin_count = 0;
    this.created_time = "";
    this.favorable_price = 0;
    this.id = "";
    this.invoice = "";
    this.no = "";
    this.operator = "";
    this.original_price = 0;
    this.pay_money = 0;
    this.pay_platform = "";
    this.present_count = 0;
    this.status = "";
    this.type = "";
    this.currency = "";
  }
};
CoinHistoryModel.model = "coin.order.detail";
CoinHistoryModel = __decorateClass([
  Annotation.ModelMeta
], CoinHistoryModel);
export let CoinOrderModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.order = new CoinHistoryModel();
    this.url = "";
  }
};
CoinOrderModel.model = "payment.qrcode";
CoinOrderModel = __decorateClass([
  Annotation.ModelMeta
], CoinOrderModel);
